import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Rockwood Estate',
    description: "A private, gated enclave of fourteen freestanding, single-storey three-bedroom homes in central Hillcrest, KwaZulu-Natal. Level living, level gardens, built-in fireplaces and double garages.",
    url: getOrigin(),
    // Social share image (16:9), served from the site's own CDN
    ogImage: 'https://rockwood-estate.cdn.modulify.website/share/rockwood-estate-hero.jpg'
}

// Public site navigation, in page order
export const mainNav: Array<NavLink> = [
    { label: 'The Estate', href: '/#estate' },
    { label: 'Residences', href: '/#residences' },
    { label: 'Lifestyle', href: '/#lifestyle' },
    { label: 'Location', href: '/#location' }
]

// Resident portal navigation
export const portalNav: Array<NavLink> = [
    { label: 'Overview', href: '/residents/dashboard' },
    { label: 'Notices', href: '/residents/notices' },
    { label: 'Documents', href: '/residents/documents' },
    { label: 'Gate access', href: '/residents/gate-access' }
]
